import React from 'react';
import { connect } from 'react-redux';
import { withState, withHandlers, compose, lifecycle } from 'recompose';
import { t } from '../../../../modules/infra/i18n';
import confirmModal from '../../../common/confirmModal';

import { closeConfirmModal } from '../../../common/confirmModal/actions';
import limitValue from '../../../common/hoc/limitValue';
import withToggle from '../../../common/hoc/withToggle';
import Money from '../../../common/money';
import OpenCashRegister from '../components/OpenCashRegister';
import { withActionByRole } from '../../../common/helpers/actions';
import { canUserOpenCashDrawerManually } from '../../../common/helpers/users';
import withPermissions from '../../../auth/utils/withPermissions';
import {
  getIsRentalBarber,
  getIsShop,
  activeShopDefaultCashDrawerBalance,
} from '../../../auth/selectors';
import {
  openShopCashRegister,
  openBarberCashRegister,
  openCashRegisterDrawer,
  fetchShopLastClosedCashRegister,
  fetchBarberLastClosedCashRegister,
} from '../actions';
import { getLastClosedCashRegisterBalance } from '../selectors';
import withCountBills from './withCountBills';

export default compose(
  withPermissions,
  withCountBills,
  withToggle('countBillsModal'),
  connect((state, ownProps) => ({
    canOpenPhysicalCashDrawer: canUserOpenCashDrawerManually(ownProps.permissions, getIsRentalBarber(state)),
    lastClosedRegisterBalance: getLastClosedCashRegisterBalance(state),
    defaultCashDrawerBalance: getIsShop(state) ? activeShopDefaultCashDrawerBalance(state) : 0,
  }), {
    openCashRegisterDrawer,
    closeConfirmModal,
  }),
  withActionByRole('openCashRegister', openShopCashRegister, openBarberCashRegister),
  withActionByRole('getLastClosedCashRegister', fetchShopLastClosedCashRegister, fetchBarberLastClosedCashRegister),
  withState('value', 'setValue', 0),
  limitValue(999999),
  withHandlers({
    onCountBillsClick: props => () => {
      props.closeConfirmModal();
      props.countBillsModalOn();
    },
  }),
  withHandlers({
    onChange: props => value => props.setValue(value),
    openCashRegister: props => async (event) => {
      event.preventDefault();

      if (props.countBillsByDefault.whenOpening) {
        props.countBillsModalOn();
        return;
      }

      let isCountingBills = false;
      const onCountBillsClick = () => {
        isCountingBills = true;
        props.onCountBillsClick();
      };

      const confirmed = await confirmModal({
        type: 'yesno',
        title: t('register:cash_register.open_register_confirm_title'),
        message: (
          <div className="u-fontsize-normal">
            <div>
              {t('register:cash_register.open_register_confirm_message').replace('{{amount}}', '')}
              {' '}<Money>{props.value}</Money> balance?{' '}
              {
                props.suggestCountingBills.whenOpening && (
                  <span onClick={onCountBillsClick} className="c-btn--link u-cursor-pointer">
                    {t('register:cash_register.count_bills_instead')}
                  </span>
                )
              }
            </div>
          </div>
        ),
        confirmButtonText: t('common:buttons.yes'),
        negativeButtonText: t('common:buttons.no'),
      });

      if (confirmed && !isCountingBills) {
        return props.openCashRegister(props.value);
      }

      return false;
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getLastClosedCashRegister().then(() =>
        this.props.setValue(this.props.defaultCashDrawerBalance || this.props.lastClosedRegisterBalance)
      );
    },
  }),
)(OpenCashRegister);
